export enum ModelApiKey {
  Index = 'index',
  Page = 'page',
  Article = 'article',
  Job = 'job'
}
